import { type StartEditingEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse, type SelectionReducerPolicies } from './types';

export function requestCellEditReducer(
  state: SelectionState,
  event: StartEditingEvent,
  policies: SelectionReducerPolicies
): ReducerResponse {
  if (!state.focusedCell) {
    return { next: state, delta: { kind: 'noop' } };
  }

  if (!policies.canRequestCellEdit(state.focusedCell)) {
    return { next: state, delta: { kind: 'noop' } };
  }

  return {
    next: { ...state, isEditing: true },
    delta: {
      kind: 'cellEditRequested',
      position: state.focusedCell,
      source: event.source,
      editingContext: event.editingContext ?? 'table',
      initialKey: event.initialKey,
    },
  };
}
